module.exports = __webpack_public_path__ + "static/media/Stellar Neo King Headboard - 180 cm_Black.2024a2d9.png";